module.exports = __webpack_public_path__ + "img/loading.33270b89.svg";